import {
  Account,
  AccountCreationConfirmationRequest,
  Identifiable,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function confirmAccountCreation(httpClient: HttpClient) {
  return ({
    planzone,
    hasRequestedPlanzoneCreation,
    userId,
    passwordConfirmation,
    ...account
  }: AccountCreationConfirmationRequest) =>
    new Promise<Identifiable<Account>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<Account>>({
          endpoint: `/api/users/${userId}`,
          method: HttpMethods.PATCH,
          data: { ...account, enabled: true },
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { confirmAccountCreation };
